import React from 'react';
import { connect } from 'react-redux';
import { useLocation } from 'react-router-dom';
import hospitalIcon from '../../../assets/icons/hospital-building.svg';
import './ContentHeader.scss';

const ROUTE_META = {
  '/studies': { title: 'All Studies', subtitle: 'Manage and review medical imaging studies' },
  '/projects': { title: 'My Projects', subtitle: 'Annotation tasks and research projects' },
  '/label-management': { title: 'Label Management', subtitle: 'Organize and categorize your studies' },
  '/worklist': { title: 'My Worklist', subtitle: 'Your assigned studies for review' },
  '/study-list': { title: 'Project Detail', subtitle: 'Data, tasks, and settings' },
};

// Tenant id (JWT hospital_id) → display name. Ids not listed fall back to a
// prettified id so new tenants still get a sensible badge without a deploy.
const HOSPITAL_NAMES = {
  ayder: 'Ayder Comprehensive Specialized Hospital',
  aksum: 'Aksum Comprehensive Specialized Hospital',
  alpha: 'Alpha Hospital',
  rimna: 'Rimna Hospital',
  alula: 'Alula Hospital',
  teleradiology: 'Afya Teleradiology',
};

const hospitalDisplayName = (hospitalId) => {
  if (!hospitalId) return '';
  if (HOSPITAL_NAMES[hospitalId]) return HOSPITAL_NAMES[hospitalId];
  return hospitalId
    .replace(/[-_]+/g, ' ')
    .replace(/\b\w/g, (c) => c.toUpperCase());
};

const ContentHeader = ({ onUploadClick, onProjectUploadClick, profile = {} }) => {
  const location = useLocation();
  const pathname = location.pathname;
  const hospitalName = hospitalDisplayName(profile?.hospital_id);

  // Match exact route or fall back to prefix match for nested routes like /study-list/:id
  const meta = ROUTE_META[pathname] ||
    Object.entries(ROUTE_META).find(([key]) => pathname.startsWith(key))?.[1] ||
    { title: '', subtitle: '' };

  return (
    <header className="content-header">
      <div className="content-header-inner">
        <div className="content-header-left">
          <h1 className="content-header-title">{meta.title}</h1>
          {meta.subtitle && (
            <p className="content-header-subtitle">{meta.subtitle}</p>
          )}
        </div>
        <div className="content-header-right">
          {hospitalName && (
            <span className="content-header-hospital" title="Your facility">
              <img src={hospitalIcon} alt="" className="content-header-hospital-icon" />
              {hospitalName}
            </span>
          )}
        </div>
      </div>
    </header>
  );
};

export default connect((state) => ({ profile: state.system.profile }))(ContentHeader);
